import type { DynamicTableConfig, Page } from '../../types';
import { CORE_DEPARTMENTS } from '../core/coverSheet';

export const crossGovernmentPathwayDescription =
  'The purpose of this data collection is to understand departmental usage of Pathways, Vacancy/ Roles origins for cross-government pathways to assess progress against the GFiE 5% ambition of appointments.\n\nThis data will enable the GFiE team to advise each Department on the schemes they utilise, their recruitment progress, and their proximity to the 5% ambition.';

export const crossGovernmentPathwayTable: DynamicTableConfig = {
  rowHeader: 'Cross Government Pathway Name',
  rowHeaderInput: {
    inputType: 'text',
  },
  columns: [
    {
      key: 'departmentsUsingPathway',
      label: 'Departments using your Pathway',
      hint: 'List the departments (one per row) using this Pathway for {report-period.dateRange} ({report-period.quarterNumber}).',
      inputType: 'text',
    },
    {
      key: 'totalDepartmentalRolesRecruited',
      label: 'Total Departmental Roles recruited',
      hint: 'Enter the total number of roles recruited by those departments for {report-period.dateRange} ({report-period.quarterNumber}).',
    },
    {
      key: 'notes',
      label: 'Notes',
      hint: 'Add any useful context about the figures entered.',
      inputType: 'text',
      required: false,
      fillRemainingWidth: true,
    },
  ],
  rows: [
    {
      key: 'total',
      label: 'Total',
      enabled: false,
      calculation: 'columnSum',
    },
  ],
  continuous: true,
  headerLineLimit: 2,
  compact: true,
  stickyHeaders: true,
  stickyRowHeader: true,
  highlightActive: true,
  height: 640,
};

export const submitterDetails: Page[] = [
  {
    pageType: 'question',
    title: '1.1 Submitter details',
    name: 'submitter-details',
    description:
      'Many thanks for completing this return. By sharing this information you are helping us to get a picture of activity across all accredited Pathways.',
    questions: [
      {
        questionType: 'reportPeriod',
        title: 'Period of Report',
        name: 'report-period',
        defaultValue: 'auto',
        rules: { required: true },
      },
      {
        questionType: 'textInput',
        title: 'Contact email',
        name: 'pathways-contact-email',
        userEmail: true,
        rules: { required: true, email: true },
      },
      {
        questionType: 'select',
        title: 'Department',
        name: 'pathways-department',
        options: CORE_DEPARTMENTS,
        rules: { required: true },
      },
    ],
  },
];

export const crossGovernmentPathwayInformation: Page[] = [
  {
    pageType: 'question',
    title: 'Cross Government Pathway Information',
    name: 'cross-government-pathway-information',
    limitWidth: false,
    description: crossGovernmentPathwayDescription,
    questions: [
      {
        questionType: 'dynamicTable',
        title: 'Cross Government Pathway Information',
        name: 'pathways-cross-government-pathway-information',
        hint: 'Please provide data for the period {report-period.dateRange} ({report-period.quarterNumber})',
        rules: { required: true },
        dynamicTable: crossGovernmentPathwayTable,
      },
    ],
  },
];

const annexB: Page[] = [...submitterDetails, ...crossGovernmentPathwayInformation];

export default annexB;
